import React, { useState, useEffect, useRef } from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  SecondaryNavCommunications,
} from "../../../../components/AdminComponents/MenuItems";

import ThirdBar from "../../../../components/AdminComponents/ThirdBar";
import {
  BackwardOutlined,
  RetweetOutlined,
  InfoCircleTwoTone,
  SaveOutlined,
  PlusCircleTwoTone,
} from "@ant-design/icons";
import {
  Row,
  Col,
  Input,
  Popover,
  Tag,
  Button,
  Select,
  Card,
  message,
  Tooltip,
  Skeleton,
  Spin,
  Form,
} from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  capitalizeWords,
  getFullApplicationName,
  ModuleColor,
  UserTypeColor,
} from "../../../../components/icons/ApplicationColor";
import Axios from "../../../../api/Axios";
import { useNavigate } from "react-router-dom";
import { generateFinalTextWithoutButtons, quillModules } from "./helper";
import VariableAccess from "../../../../components/VariableAccess";
import { useSelector } from "react-redux";

const AddTemplates = () => {
  const history = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [text, setText] = useState("");
  const [fields, setFields] = useState([]);
  const [types, setTypes] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [subCategory, setSubCategory] = useState([]);
  const [invalidFields, setInvalidFields] = useState([]);
  const [allowedVariables, setAllowedVariables] = useState([]);
  const [loading, setLoading] = useState(false);
  const [varloading, setVarLoading] = useState(false);
  const availableRoles = ["admin", "trainer", "attendee"];
  const userInfo = useSelector((state) => state.user);
  const [form] = Form.useForm();

  const [applications, setApplications] = useState([]);
  const [category, setCategory] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const UpdateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Email template updated successfully",
      duration: 5,
    });
  };
  // eslint-disable-next-line no-unused-vars
  const UpdateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Email template update failed",
      duration: 5,
    });
  };

  const extractFields = (text) => {
    const regex = /{{([^}]+)}}/g;
    const matches = [...text?.matchAll(regex)];
    const extractedFields = matches?.map((match) => match[1]);

    const invalidFields = extractedFields?.filter(
      (field) => !allowedVariables.includes(field)
    );

    setInvalidFields(invalidFields);
    return extractedFields.filter((field) => allowedVariables?.includes(field));
  };

  useEffect(() => {
    const parsedFields = extractFields(text);
    setFields(parsedFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, allowedVariables]);

  const thirdMenuData = [
    {
      path: `/ca-admin/organization/communications/templates/add-template/`,
      name: "ADD TEMPLATE",
      icon: (
        <PlusCircleTwoTone
          style={{ fontSize: "15.5px", marginRight: "2.5px", margintop: "1px" }}
        />
      ),
    },
  ];

  const handleTypeChange = (selectedRoles) => {
    setTypes(selectedRoles);
  };
  const handleCatChange = (selectedRoles) => {
    setSelectedCategory(selectedRoles);
    setSelectedSubCategory(null);
    form.setFieldValue("second_category", null);
    form.validateFields(["second_category"]);

    LoadSubCategory(selectedRoles);
  };
  const addEmailTemplate = async (data) => {
    setLoading(true);
    try {
      await Axios.post(`/mailtemplatecreate/`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });

      UpdateSuccessfull();
      Loadafter3sec();
    } catch (err) {
      //console.log(err);
      setLoading(false);
      UpdateFailed();
    }
  };
  const handleSubmit = (values) => {
    let type = "";
    if (values.type) {
      type = values.type;
    } else {
      type = category.find((app) => app.id === selectedCategory)?.name;
    }
    const payload = {
      ...values,
      application: selectedModule,
      variables: allowedVariables,
      organization: userInfo?.data?.organization?.id,
      type: type,
      body: generateFinalTextWithoutButtons(text),
    };
    addEmailTemplate(payload);
    console.log("Submitting Payload:", payload);
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const [selectedModule, setSelectedModule] = useState(null); // State to track selected module
  const typeOptions = {
    TL: ["Event"],
    TC: ["Engagement"],
    RC: [],
    CBR: [],
  };
  // Handle changes in MODULE dropdown
  const handleModuleChange = (value) => {
    setSelectedModule(value);
    setTypes(null);
    if (value !== "CB") {
      form.setFieldValue("type", null);
      form.validateFields(["type"]);
    }
    setAllowedVariables([]);
    if (value === "CB") {
      LoadCategory(value);
    }
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const callVariables = async (params) => {
    try {
      const res = await Axios.post("/templatedetails/", params, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      console.log(res, "res-res");
      setAllowedVariables(res?.data?.variables);
      setVarLoading(false);
    } catch (err) {
      console.log(err.response.data.detail);
      setVarLoading(false);
    }
  };
  const Loadafter3sec = () => {
    setTimeout(() => {
      setLoading(false);
      history("/ca-admin/organization/communications/templates");
    }, 2000);
  };

  useEffect(() => {
    if (selectedModule !== null && types !== null) {
      setVarLoading(true);
      const payload = {
        application: selectedModule,
        type: types,
      };
      callVariables(payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [types, selectedModule]);
  useEffect(() => {
    if (selectedModule !== null && selectedCategory !== null) {
      const app = category.find((app) => app.id === selectedCategory);
      setVarLoading(true);
      const payload = {
        application: selectedModule,
        type: app?.name,
      };
      callVariables(payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory, selectedModule]);
  const formRef = useRef();
  const quillRef = useRef(null);
  const handleButtonClick = (value) => {
    const editor = quillRef.current.getEditor();
    editor.focus();
    const selection = editor.getSelection();
    if (selection && typeof selection.index === "number") {
      const position = selection.index;
      console.log(quillRef, editor, selection, position);
      editor.insertText(position, ` {{${value}}} `);
      editor.setSelection(position + 5 + value.length);
    } else {
      console.log("No selection or cursor position found.");
    }
  };
  const LoadApplications = async () => {
    try {
      const res = await Axios.get("/subapplication/");
      const apps = res.data;

      // Filter and format data as required
      const filteredApps = [];

      apps.forEach((app) => {
        if (app.name === "CompBldr") {
          filteredApps.push({
            name: app.name,
            key_name: app.key_name,
            id: app.id,
          });
        } else if (Array.isArray(app.children)) {
          app.children.forEach((child) => {
            filteredApps.push({
              name: child.name,
              key_name: child.key_name,
              id: app.id,
            });
          });
        }
      });

      setApplications(filteredApps);
    } catch (err) {
      console.log(err);
    }
  };
  const LoadCategory = async (keyName) => {
    try {
      const app = applications.find(
        (app) => app.key_name.toLowerCase() === keyName.toLowerCase()
      );
      if (!app) {
        console.warn("No application found for key_name:", keyName);
        return;
      }
      const res = await Axios.get(`/category/?application=${app.id}`);
      setCategory(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const LoadSubCategory = async (id) => {
    try {
      const res = await Axios.get(`/secondcategory/?category=${id}`);
      setSubCategory(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  console.log(subCategory);
  useEffect(() => {
    LoadApplications();
  }, []);
  return (
    <CaSideNav props={CaAdminMenu}>
      {contextHolder}
      <SecondaryNav2 menuItems={SecondaryNavCommunications} />
      <Spin spinning={loading}>
        <ThirdBar menuItems={thirdMenuData} />
        <Form
          name="complex-form"
          onFinish={handleSubmit}
          layout="vertical"
          ref={formRef}
          form={form}
          labelCol={{ span: 25 }}
          wrapperCol={{ span: 80 }}
          style={{ width: "100%", marginBottom: "150px" }}
        >
          <div style={{ margin: "20px" }}>
            <Row gutter={16}>
              <Col span={15}>
                <Card
                  hoverable
                  headStyle={{
                    backgroundColor: "#879cb3",
                    color: "white",
                    padding: "5.5px",
                  }}
                  bodyStyle={{ padding: 20 }}
                  title={
                    <span
                      style={{
                        color: "white",
                        paddingLeft: "20px",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "15px",
                      }}
                    >
                      {capitalizeWords("TEMPLATE SUMMARY")}
                    </span>
                  }
                >
                  <Form.Item
                    rules={[{ required: true, message: "Title is required" }]}
                    name="title"
                    style={{
                      margin: 0,
                      padding: 0,
                      width: "95%",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="my-form-lables-withoutoverFlow"
                        style={{
                          fontSize: "14px",
                          paddingInline: "5px",
                          minWidth: "120px",
                        }}
                      >
                        {capitalizeWords("TEMPLATE TITLE")}
                      </div>
                      <Input
                        placeholder="Enter a title for the template"
                        className="my-form-input-antd-test-without-border"
                        style={{
                          marginLeft: "10px",
                        }}
                      />
                    </div>
                  </Form.Item>
                  <Form.Item
                    rules={[{ required: true, message: "Subject is required" }]}
                    name="subject"
                    style={{
                      margin: 0,
                      padding: 0,
                      width: "95%",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="my-form-lables-withoutoverFlow"
                        style={{
                          fontSize: "14px",
                          paddingInline: "5px",
                          minWidth: "120px",
                        }}
                      >
                        {capitalizeWords("EMAIL SUBJECT")}
                      </div>
                      <Input
                        placeholder="Enter the email subject"
                        className="my-form-input-antd-test-without-border"
                        style={{
                          marginLeft: "10px",
                        }}
                      />
                    </div>
                  </Form.Item>
                  <ReactQuill
                    theme="snow"
                    value={text}
                    onChange={setText}
                    ref={quillRef}
                    modules={quillModules}
                    style={{
                      height: "350px",
                      marginBottom: "40px",
                      fontFamily: "Poppins",
                    }}
                  />

                  {invalidFields.length > 0 && (
                    <div
                      style={{
                        marginTop: "20px",
                        paddingTop: "10px",
                        color: "red",
                      }}
                    >
                      {invalidFields.map((invalidField, index) => (
                        <Popover
                          key={index}
                          content={`"${invalidField}" is not a valid variable.`}
                          title="Invalid Variable"
                          trigger="hover"
                        >
                          <Tag
                            color="red"
                            style={{ fontSize: "15px", marginLeft: "10px" }}
                          >
                            {`{{${invalidField}}}`}
                          </Tag>
                        </Popover>
                      ))}
                    </div>
                  )}
                </Card>
              </Col>
              <Col span={9}>
                <Row>
                  <Card
                    hoverable
                    headStyle={{
                      backgroundColor: "#879cb3",
                      color: "white",
                      padding: "5.5px",
                    }}
                    style={{
                      width: "100%",
                    }}
                    bodyStyle={{ padding: 20 }}
                    title={
                      <span
                        style={{
                          color: "white",
                          paddingLeft: "20px",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "15px",
                        }}
                      >
                        {capitalizeWords("MODULE AND ROLE ACCESS")}
                      </span>
                    }
                  >
                    <Form.Item
                      rules={[
                        { required: true, message: "Module is required" },
                      ]}
                      name="module"
                      style={{
                        margin: 0,
                        padding: 0,
                        width: "70%",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div
                          className="my-form-lables-withoutoverFlow"
                          style={{
                            fontSize: "14px",
                            paddingInline: "5px",
                            minWidth: "85px",
                          }}
                        >
                          {capitalizeWords("MODULE")}
                        </div>

                        <Select
                          placeholder="Select Module"
                          style={{
                            width: "100%",
                          }}
                          value={selectedModule}
                          onChange={(value) => {
                            form.setFieldValue("module", value);
                            form.validateFields(["module"]);
                            handleModuleChange(value);
                          }}
                          // onChange={handleModuleChange}
                        >
                          {applications.map((role) => (
                            <Select.Option
                              key={role?.key_name}
                              value={role?.key_name}
                              style={{ paddingLeft: "20px" }}
                            >
                              <Tag
                                color={ModuleColor(
                                  getFullApplicationName(role?.key_name)
                                )}
                                key={role?.key_name}
                                title={role?.key_name}
                                style={{
                                  fontWeight: "600",

                                  fontSize: "13px",
                                }}
                              >
                                {role?.name}
                              </Tag>
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </Form.Item>
                    {selectedModule !== "CB" && (
                      <Form.Item
                        rules={[
                          { required: true, message: "Type is required" },
                        ]}
                        name="type"
                        style={{
                          margin: 0,
                          padding: 0,
                          width: "70%",
                          marginBottom: "20px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div
                            className="my-form-lables-withoutoverFlow"
                            style={{
                              fontSize: "14px",
                              paddingInline: "5px",
                              minWidth: "85px",
                            }}
                          >
                            {capitalizeWords("TYPE")}
                          </div>

                          <Select
                            placeholder="Select type"
                            style={{
                              width: "100%",
                            }}
                            value={types}
                            onChange={(value) => {
                              handleTypeChange(value);
                              form.setFieldValue("type", value);
                              form.validateFields(["type"]);
                            }}
                            disabled={!selectedModule} // Disable TYPE dropdown if no module is selected
                          >
                            {(typeOptions[selectedModule] || []).map((role) => (
                              <Select.Option
                                key={role}
                                value={role}
                                style={{ paddingLeft: "20px" }}
                              >
                                <Tag
                                  color={"magenta"}
                                  key={role}
                                  title={role}
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "13px",
                                  }}
                                >
                                  {role}
                                </Tag>
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </Form.Item>
                    )}
                    {selectedModule === "CB" && (
                      <>
                        <Form.Item
                          rules={[
                            { required: true, message: "category is required" },
                          ]}
                          name="category"
                          style={{
                            margin: 0,
                            padding: 0,
                            width: "70%",
                            marginBottom: "20px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="my-form-lables-withoutoverFlow"
                              style={{
                                fontSize: "14px",
                                paddingInline: "5px",
                                minWidth: "85px",
                              }}
                            >
                              {capitalizeWords("category")}
                            </div>

                            <Select
                              placeholder="Select category"
                              style={{
                                width: "100%",
                              }}
                              value={selectedCategory}
                              onChange={(value) => {
                                handleCatChange(value);
                                form.setFieldValue("category", value);
                                form.validateFields(["category"]);
                              }}
                              disabled={!selectedModule}
                            >
                              {category?.map((role, index) => {
                                let tagColor = "magenta";

                                if (index === 1) tagColor = "geekblue";
                                if (index === 2) tagColor = "green";

                                return (
                                  <Select.Option
                                    key={role?.id}
                                    value={role?.id}
                                    style={{ paddingLeft: "20px" }}
                                  >
                                    <Tag
                                      color={tagColor}
                                      key={role?.id}
                                      title={role?.id}
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "13px",
                                      }}
                                    >
                                      {role?.name}
                                    </Tag>
                                  </Select.Option>
                                );
                              })}
                            </Select>
                          </div>
                        </Form.Item>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "sub-category is required",
                            },
                          ]}
                          name="second_category"
                          style={{
                            margin: 0,
                            padding: 0,
                            width: "70%",
                            marginBottom: "20px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="my-form-lables-withoutoverFlow"
                              style={{
                                fontSize: "14px",
                                paddingInline: "5px",
                                minWidth: "85px",
                              }}
                            >
                              {capitalizeWords("Sub Category")}
                            </div>

                            <Select
                              placeholder="Select sub-category"
                              style={{
                                width: "100%",
                              }}
                              onChange={(value) => {
                                form.setFieldValue("second_category", value);
                                setSelectedSubCategory(value);
                                form.validateFields(["second_category"]);
                              }}
                              value={selectedSubCategory}
                              disabled={!selectedCategory}
                            >
                              {subCategory?.map((role, index) => {
                                let tagColor = "magenta";

                                if (index === 1) tagColor = "geekblue";
                                if (index === 2) tagColor = "green";

                                return (
                                  <Select.Option
                                    key={role?.id}
                                    value={role?.id}
                                    style={{ paddingLeft: "20px" }}
                                  >
                                    <Tag
                                      color={tagColor}
                                      key={role?.id}
                                      title={role?.id}
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "13px",
                                      }}
                                    >
                                      {role?.name}
                                    </Tag>
                                  </Select.Option>
                                );
                              })}
                            </Select>
                          </div>
                        </Form.Item>
                      </>
                    )}
                    <Form.Item
                      name="user_type"
                      rules={[
                        {
                          required: true,
                          message: "At least one Role is required",
                        },
                      ]}
                      style={{
                        margin: 0,
                        padding: 0,
                        width: "70%",
                        marginBottom: "0px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div
                          className="my-form-lables-withoutoverFlow"
                          style={{
                            fontSize: "14px",
                            paddingInline: "5px",
                            minWidth: "85px",
                          }}
                        >
                          {capitalizeWords("ROLE")}
                        </div>

                        <Select
                          mode="multiple"
                          placeholder="Select User Roles"
                          onChange={(value) => {
                            form.setFieldValue("user_type", value);
                            form.validateFields(["user_type"]);
                          }}
                          style={{
                            width: "100%",
                          }}
                        >
                          {availableRoles.map((role) => (
                            <Select.Option
                              key={role}
                              value={role}
                              style={{ paddingLeft: "20px" }}
                            >
                              <Tag
                                color={UserTypeColor(role)}
                                key={role}
                                title={role}
                                style={{
                                  fontWeight: "600",
                                  fontSize: "13px",
                                }}
                              >
                                {role?.toUpperCase()}
                              </Tag>
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </Form.Item>
                  </Card>
                </Row>
                <Row style={{ marginTop: "20px" }}>
                  <Card
                    hoverable
                    headStyle={{
                      backgroundColor: "#879cb3",
                      color: "white",
                      padding: "5.5px",
                    }}
                    style={{
                      width: "100%",
                      minHeight: "150px",
                    }}
                    bodyStyle={{ padding: 20 }}
                    title={
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span
                          style={{
                            color: "white",
                            paddingLeft: "20px",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "15px",
                          }}
                        >
                          {capitalizeWords("AVAILABLE VARIABLES")}
                        </span>
                        <Tooltip title="Know More">
                          <InfoCircleTwoTone
                            className="hover-icon-login"
                            style={{
                              fontSize: "20px",
                              marginRight: "5px",
                            }}
                            onClick={showModal}
                          />
                        </Tooltip>
                      </span>
                    }
                  >
                    {varloading ? (
                      <Skeleton active loading={varloading} size="small" />
                    ) : (
                      <>
                        {allowedVariables?.map((variable, index) => (
                          <Tooltip title="Click to add this variable in editor">
                            <Tag
                              key={index}
                              color={
                                fields.includes(variable) ? "green" : "blue"
                              }
                              style={{
                                fontSize: "14.5px",
                                marginBottom: "8px",
                                padding: "2.5px",
                                paddingInline: "10px",
                                fontFamily: "Poppins",
                              }}
                              onClick={() => handleButtonClick(variable)}
                            >
                              {variable}
                            </Tag>
                          </Tooltip>
                        ))}
                      </>
                    )}
                  </Card>
                </Row>
                <Row
                  style={{
                    marginTop: "40px",
                    marginLeft: "5px",
                  }}
                >
                  <Button
                    htmlType="button"
                    disabled={false}
                    onClick={() => {
                      history(
                        "/ca-admin/organization/communications/templates"
                      );
                    }}
                  >
                    <BackwardOutlined />
                    Back
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      background: "#f58029",
                      fontWeight: "600",
                      marginLeft: "20px",
                    }}
                    disabled={invalidFields.length > 0 || text === ""}
                    className="save-update-btn"
                  >
                    Save
                    <SaveOutlined />
                  </Button>
                  <Button
                    type="primary"
                    htmlType="button"
                    style={{
                      marginLeft: "20px",
                    }}
                  >
                    Reset
                    <RetweetOutlined />
                  </Button>
                </Row>
              </Col>
            </Row>
          </div>
        </Form>
        <VariableAccess
          isVisible={isModalVisible}
          handleCancel={handleCancel}
        />
      </Spin>
    </CaSideNav>
  );
};

export default AddTemplates;
